// extracted by mini-css-extract-plugin
export default {"dropzone":"Eszs7","hovered":"sd3Nj","disabled":"nx5ms","fixed":"lTOfl","visible":"x7xoI","content":"uY6kt","icon":"qed4t","label":"IVDiz","link":"Ut3_j"};